module.exports = __webpack_public_path__ + "media/images/icon__email@3x-51cf03eaac9d421d93b409158120e33d.png";